/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AgreementFromJSON, AgreementToJSON, CarFromJSON, CarToJSON, CarMakeDictionaryValueFromJSON, CarMakeDictionaryValueToJSON, } from './';
export function CarModelDictionaryValueFromJSON(json) {
    return CarModelDictionaryValueFromJSONTyped(json, false);
}
export function CarModelDictionaryValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'carMake': !exists(json, 'carMake') ? undefined : CarMakeDictionaryValueFromJSON(json['carMake']),
        'carMakeId': !exists(json, 'carMakeId') ? undefined : json['carMakeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'cars': !exists(json, 'cars') ? undefined : (json['cars'] === null ? null : json['cars'].map(CarFromJSON)),
        'agreements': !exists(json, 'agreements') ? undefined : (json['agreements'] === null ? null : json['agreements'].map(AgreementFromJSON)),
    };
}
export function CarModelDictionaryValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carMake': CarMakeDictionaryValueToJSON(value.carMake),
        'carMakeId': value.carMakeId,
        'name': value.name,
        'cars': value.cars === undefined ? undefined : (value.cars === null ? null : value.cars.map(CarToJSON)),
        'agreements': value.agreements === undefined ? undefined : (value.agreements === null ? null : value.agreements.map(AgreementToJSON)),
    };
}
